import { useAtom } from 'jotai';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { Email, Lock } from '@mui/icons-material';
import {
  Button,
  Card,
  CardContent,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import { makeStyles } from '@mui/styles';
import { MdiService } from '../utils/MdiService';

import { authTokenAtom } from '../utils/AtomConfig';

const LOGO_PATH = './full-logo.svg';

const useStyles = makeStyles({
  sop: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#e8ecf1',
  },
  logo: {
    width: 300
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
});

export function Login() {
  const classes = useStyles();
  const history = useHistory();
  const mdiService = MdiService.Instance;
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState<string>();
  const [isFetch, setIsFetch] = useState(false);
  const [, setAuthToken] = useAtom(authTokenAtom);

  function submit() {
    if (email && password) {
      setIsFetch(true);
      mdiService
        .Login(email, password)
        .then((res) => {
          if (!res || !res.data) throw new Error('Authentication token blank.');
          const _authToken = 'Bearer ' + res.data;
          setAuthToken(_authToken);
          history.push('/');
        })
        .catch((err) => {
          setToastMessage('Login failed. Please check again your email and password.');
          console.error('Login failed', err)
          setShowToast(true);
          if (
            err.response.data ===
            'Your password needs to be changed before you can log-in.'
          ) {
            history.push('/reset/password');
          }
        })
        .finally(() => {
          setIsFetch(false);
        });
    } else {
      setToastMessage('Please Input Your Email And Password');
      setShowToast(true);
    }
  }

  return (
    <Stack>
      <div className={classes.sop}>
        <div>
          <img className={classes.logo} src={LOGO_PATH} alt='Logo'></img>
        </div>
        <div style={{ marginTop: 20, maxWidth: 450 }}>
          <Card>
            <CardContent>
              <div className={classes.textContainer}>
                <Typography
                  sx={{ fontSize: 20, fontWeight: 900, color: 'black' }}
                  gutterBottom
                >
                  Welcome Back
                </Typography>
                <Typography
                  sx={{ fontSize: 14, color: '#aeaeae' }}
                  gutterBottom
                >
                  Enter your credentials to access your account
                </Typography>
              </div>
              <div style={{ marginTop: 30 }}>
                <TextField
                  onChange={(e) => setEmail(e.target.value)}
                  label='Email'
                  placeholder='Enter Your Email'
                  variant='outlined'
                  size='small'
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Email></Email>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyUp={(event) => {
                    if (event.key === 'Enter') {
                      submit()
                    }
                  }}
                  type='password'
                  label='Password'
                  placeholder='Enter your password'
                  size='small'
                  fullWidth
                  variant='outlined'
                  style={{ marginTop: 20 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Lock></Lock>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  onClick={() => submit()}
                  fullWidth
                  style={{ marginTop: 20 }}
                  variant='contained'
                >
                  {isFetch ? (
                    <CircularProgress size={25} color='inherit' />
                  ) : (
                    'Sign In'
                  )}
                </Button>
              </div>
            </CardContent>
          </Card>
          <div className={classes.textContainer} style={{ marginTop: 20, flexDirection: 'initial' }}>
            <Link to='/reset/password'>Change Password</Link>
            <Typography
              sx={{ fontSize: 20, fontWeight: 900, color: 'rgba(0,0,0,0.5)', display: 'inline', 
              marginTop: '-7px', marginLeft: '10px', marginRight: '10px', cursor: 'default' }}
            >
              .
            </Typography>
            <a href={`${process.env.REACT_APP_FORMS_BASE_URL}?id=${process.env.REACT_APP_FORGOTTEN_PASSWORD_FORM_ID}`} target='_blank'>Forgot Password</a>
            <Typography
              sx={{ fontSize: 20, fontWeight: 900, color: 'rgba(0,0,0,0.5)', display: 'inline', 
              marginTop: '-7px', marginLeft: '10px', marginRight: '10px', cursor: 'default' }}
            >
              .
            </Typography>
            <a href={`${process.env.REACT_APP_FORMS_BASE_URL}?id=${process.env.REACT_APP_SELF_REGISTER_FORM_ID}`} target='_blank'>Register</a>
          </div>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={showToast}
        autoHideDuration={3000}
        onClose={() => setShowToast(false)}
        message={toastMessage}
      />
    </Stack>
  );
}
